// extracted by mini-css-extract-plugin
export var subtitle = "_cw-2";
export var title = "_cw-0";
export var titleNoWrap = "_cw-1";